module.exports = __webpack_public_path__ + "img/1.15eb4c80.png";